import React, { useState } from "react";
import {
  Box,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UploadIcon from "@mui/icons-material/Upload";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from "../../../../store";
import { uploadFacilityDocument2 } from "../../../../modules/facility/actions";
import { selectFacilityDocumentUploadLoading2 } from "../../../../modules/facility/selectors";



import {
  CancelButton,
  CloseButton,
  FileName,
  ModalContainer,
  PrimaryButton,
  Title,
  UploadBox,
  UploadText
} from "./styles";

interface UpdateDocumentModalProps {
  open: boolean;
  onClose: () => void;
  document: any;
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

const UpdateDocumentModal: React.FC<UpdateDocumentModalProps> = ({ open, onClose, document, onSuccess, onError }) => {

  const [file, setFile] = useState<File | null>(null);

  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector(selectFacilityDocumentUploadLoading2);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    if (!file && !document?.uploaded_document) {
      if (onError) {
        onError('Please select a file to upload.');
      }
      return;
    }

    const payload = {
      document: file as File,
      document_name: document.document_type.document_type,
      document_type: document.requirement_id.toString(),
    };

    const result = await dispatch(uploadFacilityDocument2(payload));
    if (result.meta.requestStatus === 'fulfilled') {
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } else if (result.meta.requestStatus === 'rejected') {
      if (onError) {
        // Try to get error message from payload or error object
        const errorMessage = typeof result.payload === 'string'
          ? result.payload
          : (result.payload as any)?.message || (result as any).error?.message || 'Failed to upload document.';
        onError(errorMessage);
      }
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <ModalContainer>

          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>

          <Title>{document?.uploaded_document ? 'Update' : 'Add'} Document</Title>

          {/* Upload Box */}
          <label>
            <UploadBox>
              <input type="file" hidden onChange={handleFileChange} />
              <UploadIcon sx={{ fontSize: 40, color: '#6f9e88' }} />
              <UploadText>
                Drag & Drop or Click to Upload (.pdf, .jpg, .png)
              </UploadText>
              <FileName>{file?.name || document?.uploaded_document?.document_url?.split('/').pop() || 'No File Uploaded'}</FileName>
            </UploadBox>
          </label>

          {/* Buttons */}
          <PrimaryButton onClick={handleSubmit} disabled={loading}>{loading ? 'Uploading...' : (document?.uploaded_document ? 'Update' : 'Add') + ' Document'}</PrimaryButton>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        </ModalContainer>
      </Box>
    </Modal>
  );
};

export default UpdateDocumentModal;
